import { render, staticRenderFns } from "./actionsBox.vue?vue&type=template&id=557f9d71&scoped=true"
import script from "./actionsBox.vue?vue&type=script&lang=js"
export * from "./actionsBox.vue?vue&type=script&lang=js"
import style0 from "./actionsBox.vue?vue&type=style&index=0&id=557f9d71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f9d71",
  null
  
)

export default component.exports